export default class WS {
  constructor(url, options = {}) {
    // 配置参数
    this.url = url
    this.options = options
    // 内部状态
    this.ws = null
  }

  /**
   * 连接 WebSocket
   */
  connect() {
  //  readyState	Number	连接当前状态：
  // ⚫ 0 - CONNECTING（连接中）
  // ⚫ 1 - OPEN（已连接，通信中）
  // ⚫ 2 - CLOSING（关闭中）
  // ⚫ 3 - CLOSED（已关闭）
    if(!this.url || !this.options.onmessage){
      console.log('websocket:启动ws失败,缺少url或者onmessage')
      return
    }
    if(this.ws){
      console.log('websocket:启动ws失败,已存在链接')
      return
    }
    try {
      this.ws = new WebSocket(this.url)
      this.ws.onopen = (...arg) => {
        this.options.onopen && this.options.onopen(...arg)
      }
      this.ws.onclose = (...arg) => {
        this.ws = null
        this.options.onclose && this.options.onclose(...arg)
      }
       this.ws.onerror = (...arg) => {
        this.ws = null
        this.options.onclose && this.options.onerror(...arg)
      }
      this.ws.onmessage = (event) => {
        this.options.onmessage && this.options.onmessage(event)
      }
    } catch (error) {
      console.error('websocket:启动ws失败', error)
    }
  }

  /**
   * 发送消息
   */
  send(data) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      try {
        const message = typeof data === 'string' ? data : JSON.stringify(data)
        this.ws.send(message)
        return true
      } catch (error) {
        console.error('[WSConnection] 发送消息失败:', error)
        return false
      }
    }
    console.error('[WSConnection] 发送消息失败:ws状态不对', this.ws && this.ws.readyState)
    return false
  }

  /**
   * 关闭连接
   */
  close() {
    if (this.ws) {
      try {
        this.ws.close()
      } catch (error) {
        console.error('[WSConnection] 关闭 WebSocket 失败:', error)
      }
    }
  }

}